import { clsx } from '../../../ds/clsx';
import { Banner, Skeleton } from '../../../ds/components';
import { errorMessage } from '../../../lib/api';
import { useFinancingHistory } from '../api';
import type { Tone } from '../types';
import styles from './record.module.css';

const dotClass: Record<Tone, string | undefined> = {
  accent: styles.dotAccent,
  success: styles.dotSuccess,
  danger: styles.dotDanger,
  info: styles.dotInfo,
  neutral: undefined,
};

/** Tab „Verlauf" (`GET /financings/:id/history`) in the timeline style of Deal-Akte 10: days, time, dot, title, actor. */
export function HistoryMain({ financingId }: { financingId: string }) {
  const history = useFinancingHistory(financingId, true);
  return (
    <section className={styles.card} aria-label="Verlauf">
      {history.isPending ? (
        <div className={styles.skeletonStack} aria-busy="true">
          <Skeleton width="30%" height={10} />
          <Skeleton variant="block" height={40} />
          <Skeleton variant="block" height={40} />
        </div>
      ) : null}
      {history.isError ? <Banner tone="danger">{errorMessage(history.error)}</Banner> : null}
      {history.data && history.data.days.length === 0 ? (
        <div className={styles.muted}>Noch keine Einträge.</div>
      ) : null}
      {history.data?.days.map((day) => (
        <div key={day.day}>
          <div className={styles.historyDayLabel}>{day.label}</div>
          {day.entries.map((entry) => (
            <div key={entry.id} className={styles.historyRow}>
              <span className={styles.historyTime}>{entry.time}</span>
              <span className={clsx(styles.historyDot, dotClass[entry.tone])} aria-hidden="true" />
              <span>
                <div className={styles.historyTitle}>{entry.title}</div>
                {entry.text ? <div className={styles.historyText}>{entry.text}</div> : null}
              </span>
              <span className={styles.historyActor}>{entry.actorShort}</span>
            </div>
          ))}
        </div>
      ))}
    </section>
  );
}
